export const documentsPageInset = "px-6 sm:px-8";

export const documentsPageToolbar =
	"flex flex-col gap-3 border-b border-border/60 bg-background/80 backdrop-blur-sm";

export const documentsPageBodyInset = "px-6 py-6 sm:px-8 sm:py-8";

export const documentsTableCard =
	"overflow-hidden rounded-xl border border-border/80 bg-card/40";

export const documentsCardGrid =
	"grid w-full grid-cols-[repeat(auto-fill,minmax(min(100%,11rem),1fr))] gap-4 @md:gap-5";
